import {Repository} from '@/repositories/Base/Repository'

class TypeRepository extends Repository {
    endpoint = 'mapping/type'

}

export default new TypeRepository()
